module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 239
// module chunks = 13